"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackClickTextLink = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackClickTextLink(clickText, clickUrl, clickElement) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickTextLink,
        feature_category: enums_1.GA4FeatureCategory.Search,
        click_element: clickElement,
        click_text: clickText,
        click_url: clickUrl,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        event: 'JS_Event',
        eventCategory: enums_1.EventCategory.Search,
        eventAction: enums_1.SearchEventType.TextClick,
        eventLabel: enums_1.GA4EventLabel.More,
        eventValue: undefined,
        nonInteraction: false,
        eventData,
    });
}
exports.trackClickTextLink = trackClickTextLink;
//# sourceMappingURL=trackClickTextLink.js.map